import { Icon } from '@chakra-ui/react';

export const BumpIcon = () => (
  <Icon boxSize={5}>
    <svg viewBox="0 0 20 20">
      <path
        d="M15.4196 12.068L10.732 6.20857C10.5088 5.93048 10.0396 5.93048 9.81648 6.20857L5.12891 12.068C4.82285 12.4512 5.09626 13.0202 5.58669 13.0202H7.34453V17.7077C7.34453 18.0316 7.6066 18.2937 7.93047 18.2937H12.618C12.9419 18.2937 13.204 18.0316 13.204 17.7077V13.0202H14.9618C15.4523 13.0202 15.7256 12.4512 15.4196 12.068Z"
        fill="currentColor"
      />
      <path
        d="M15.4189 8.06802L10.7313 2.20857C10.5082 1.93048 10.039 1.93048 9.81579 2.20857L5.12822 8.06802C4.92623 8.32096 4.96744 8.68944 5.21979 8.89202C5.47385 9.09573 5.84179 9.05225 6.04378 8.80045L9.49266 4.48888C9.89299 3.98842 10.6541 3.98842 11.0545 4.48888L12.3885 6.15655L14.5034 8.80045C14.7073 9.05362 15.0753 9.09331 15.3273 8.89202C15.5797 8.68944 15.6209 8.32096 15.4189 8.06802Z"
        fill="currentColor"
      />
    </svg>
  </Icon>
);
